export function removeDuplicateTags( array, key ){
    console.log('Vue Tools: Remove Duplicate Tags');
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
}

export function removeByKey( array, params ){
    console.log('Vue Tools: Remove By Key');

    array.some(function(item, index) {
        if(array[index][params.key] === params.value){
            array.splice(index, 1);
            return true;
        }
        return false;
    });

    return array;
}